import getMenu from './menu';

export default {
  getMenu,
};
